import { useTranslation } from "react-i18next";

import { DashboardSummary } from "@components/organisms/dashboardSummary";
import { useGetStaffProfileStatistics } from "@api/system";

export function StaffDashboard() {
  const { t } = useTranslation("field");

  const { data, isFetching, isError } = useGetStaffProfileStatistics();

  return (
    <DashboardSummary
      items={[
        {
          key: "academicFieldCount",
          name: t("academicFieldCount"),
          value: data?.data?.total_academic_groups || 0,
        },
        {
          key: "facultyMemberCount",
          name: t("facultyMemberCount"),
          value: data?.data?.total_faculty_members || 0,
        },
      ]}
      isLoading={isFetching}
      isError={isError}
    />
  );
}
